import { useQuery } from '@tanstack/react-query';
import { doctorsApi, type DoctorStatistics } from '@/api';

const DOCTOR_STATISTICS_KEY = ['doctor', 'statistics'] as const;

async function fetchDoctorStatistics(): Promise<DoctorStatistics> {
  return doctorsApi.getMyStatistics();
}

export function useDoctorStatistics() {
  return useQuery({
    queryKey: DOCTOR_STATISTICS_KEY,
    queryFn: fetchDoctorStatistics,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    retry: 2,
  });
}
